import { render } from "./Error404View.vue?vue&type=template&id=540f4806&ts=true"
import script from "./Error404View.vue?vue&type=script&lang=ts"
export * from "./Error404View.vue?vue&type=script&lang=ts"

import exportComponent from "c:\\www\\.dev\\.vue\\n3t.bitbucket.io\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__